'use client';

import FilterBuilder from '../utils/filterBuilder';
import { fleetApi } from '../api/axiosClient';

const getTzParam = () => `?tz=${Math.abs(new Date().getTimezoneOffset() / 60)}`;

export const getTireEquipVehicle = async (companyId, vehicleId) => {
  try {
    const fb = new FilterBuilder()
      .setPaging(0, 1)
      .equal('company_id', String(companyId))
      .equal('vehicle_id', String(vehicleId))
      .setOrder(['last_update'], false);
    const response = await fleetApi.post(`/tire-equip-vehicle/search${getTzParam()}`, fb.build());
    return response.data?.data || response.data || [];
  } catch (error) {
    console.error('Failed to fetch tire equip vehicle:', error);
    throw error;
  }
};

export const createTireTransaction = async (payload) => {
  try {
    const response = await fleetApi.post(`/tire-transactions/new${getTzParam()}`, payload);
    if (response?.data?.status === false || response?.data?.code >= 400 || response?.data?.code >= 403 || response?.data?.error) {
      throw { response: { data: response.data } };
    }
    return response.data;
  } catch (error) {
    console.error('Error creating tire transaction:', error);
    throw error;
  }
};
